import { PropsWithChildren, useRef } from 'react';

import {
  createMappingFormatterStore,
  MappingFormatterContext,
  MappingFormatterProps,
  MappingFormatterStore,
} from './mappingFormatterStore';

type MappingFormatterProviderProps = PropsWithChildren<MappingFormatterProps> & {
  formatterId?: string;
};

export const MappingFormatterProvider = ({ formatterId, children, ...props }: MappingFormatterProviderProps) => {
  const storeRef = useRef<MappingFormatterStore>(null);

  if (!storeRef.current) {
    storeRef.current = createMappingFormatterStore(formatterId, props);
  }

  if (storeRef.current?.getState().formatterId !== formatterId) {
    storeRef.current = createMappingFormatterStore(formatterId, props);
  }

  return <MappingFormatterContext.Provider value={storeRef.current}>{children}</MappingFormatterContext.Provider>;
};
